import { ProtoBaseModel, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import InventoryEvent from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-event';
export default ProtoBaseModel.extend({
  inventoryEvents: repeated(InventoryEvent)
});